import React from 'react';
import '../myutils';
import { connect } from 'react-redux';
import { Layout, Sidebar, Notification } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import { darkTheme, lightTheme } from './themes';

const CustomSidebar = props => <Sidebar {...props} size={250}  width={'xs'} />;
const NoNotification = props => <Notification {...props} autoHideDuration={0} />;
const CustomLayout = props => (
    <Layout {...props} appBar={AppBar} sidebar={CustomSidebar} menu={Menu} notification={NoNotification}/>
);

export default connect(
    state => ({
        theme: state.theme === 'dark' ? darkTheme : lightTheme,
    }),
    {}
)(CustomLayout);
